import React, { ReactNode } from "react";

import { StaggeredSplitBlock as Value } from "@reactivated";

import { HeroLayoutSettings } from "@thelabnyc/thelabui/src/components/Flexihero/HeroLayout.interfaces";
import { HeroSet } from "@thelabnyc/thelabui/src/components/Flexihero/HeroSet";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { MediaChooserBlock } from "../MediaChooserBlock";
import { RichText } from "../RichText";

import styles from "./index.module.scss";

interface Props {
    media: ReactNode | null;
    content: ReactNode | null;
    contentAlignment: Value["content_alignment"];
    blockHeight: Value["block_height"];
}

const StaggeredSplit = ({
    content,
    media,
    contentAlignment,
    blockHeight,
}: Props) => {
    // static name to hook into for interblock styling
    const sharedRootClassName = "staggeredSplitBlockGlobal";

    const sharedStyles = {
        contentClassName: styles.content,
        innerClassName: styles.inner,
        mediaClassName: styles.media,
        rootClassName: sharedRootClassName,
    };

    const settings: HeroLayoutSettings = {
        heroDirection: "row",
        heroPlacement: "full",
        mediaPlacement: "inline",
        mediaAspectRatio: "stretch",
        contentAlignPrimary: "middle",
        contentAlignSecondary:
            contentAlignment === "left" ? "left/top" : "right/bottom",
        textAlignment: "left",
        contentWidth: 6,
    };

    return (
        <HeroSet
            layouts={{
                desktop: {
                    content,
                    media,
                    settings,
                    styles: {
                        ...sharedStyles,
                        rootClassName: concatClassNames([
                            blockHeight ? styles[blockHeight] : "",
                            sharedRootClassName,
                        ]),
                    },
                },
                mobile: {
                    content,
                    media,
                    settings: {
                        ...settings,
                        heroDirection: "column",
                        contentAlignSecondary: "right/bottom",
                        contentWidth: 12,
                        textAlignment: "center",
                    },
                    styles: sharedStyles,
                },
            }}
        />
    );
};

export const StaggeredSplitBlock = ({ value }: { value: Value }) => {
    return (
        <StaggeredSplit
            content={value.content ? <RichText value={value.content} /> : null}
            media={value.media && <MediaChooserBlock value={value.media} />}
            contentAlignment={value.content_alignment}
            blockHeight={value.block_height}
        />
    );
};
